import { COLORS } from '@btime/constants'
import React from 'react'

import AbsoluteWithMenuSpacePageTemplate from '../../../components/templates/AbsoluteWithMenuSpacePageTemplate'
import Container from '../../../components/structure/Container'
import FlexGrid from '../../../components/structure/FlexGrid'
import PageHeader from './PageHeader'
import Panel from '../../../components/structure/Panel'
import Separator from '../../../components/helpers/Separator'

const LoggedProfilePage = () => {
  return (
    <AbsoluteWithMenuSpacePageTemplate bgColor={COLORS.white}>
      <Container maxWidth="68rem">
        <PageHeader />

        <FlexGrid gutter={0.5} align="stretch">
          <Separator weight={12} vertical />

          <Panel noMargin flex={1} lineBorder />

          <Separator weight={12} vertical />
        </FlexGrid>
      </Container>
    </AbsoluteWithMenuSpacePageTemplate>
  )
}

export default LoggedProfilePage
